// 主app的api
const MainAppApi = {
  // 关闭
  close: function (options, successcb, errorcb) { },
  // 上传图片
  uploadImg: function (options, successcb) {
    window.AHAPP.invokeNative('uploadimgv2', {
      storagePermissionDesc: '需要您授权访问相册权限，否则无法完成上传图片功能',
      imgid: options.localId,
      imgquality: options.quality,
      imgwidth: options.imageW,
      imgheight: options.imageH,
      success: function (result) {
        var imgBase64 = result.result.imgbase64.split(',')[1]
        successcb({ imgId: '', imgBase64: imgBase64 })
      },
      fail: function (result) {
        console.log(JSON.stringify(result))
      }
    })
  },
  // 选择图片
  chooseImage: function (options, successcb, errorcb) {
    window.AHAPP.invokeNative('chooseimg', {
      sourcetype: 'select',
      cameraPermissionDesc: '需要使用您相册图片，否则无法完成上传图片及拍照功能',
      storagePermissionDesc: '需要您授权访问相册权限，否则无法完成上传图片功能',
      success: function (result) {
        var imgid = result.result.imgid
        window.AHAPP.invokeNative('uploadimgv2', {
          storagePermissionDesc: '需要您授权访问相册权限，否则无法完成上传图片功能',
          imgid: imgid,
          imgquality: options.quality,
          imgwidth: options.imageW,
          imgheight: options.imageH,
          success: function (updResult) {
            successcb({ imgId: imgid, imgBase64: updResult.result.imgbase64 })
          },
          fail: function (updResult) {
            console.log(JSON.stringify(updResult))
          }
        })
      },
      fail: function (result) {
        console.log(JSON.stringify(result))
      }
    })
  },
  // 跳出浏览器打开
  openBrowser: function (options, successcb, errorcb) {
    window.location = options.uri
  },
  // 获取定位信息
  getLocationInfo(successcb, errorcb) {
    window.AHAPP.invokeNative('getSyncCity', {
      success: function (result) {
        console.log(JSON.stringify(result)) // 打印客户端返回的参数内容
        successcb(result)
      },
      fail: function (result) {
        errorcb(result)
        console.log(JSON.stringify(result))
      }
    })
  },
  // 同步定位信息
  getSyncCity(nowCityId) {
    window.AHAPP.invokeNative('getSyncCity', {
      success: function (ret) {
        if (
          parseInt(ret.result.cityId) &&
          parseInt(ret.result.cityId) !== parseInt(nowCityId)
        ) {
          window.location.reload(false)
        }
      },
      fail: function (result) {
        console.log(JSON.stringify(result))
      }
    })
  },
  // 更新定位信息
  updatecity(item) {
    if (item) {
      window.AHAPP.invokeNative('updatecity', {
        cityid: item.cityId,
        success: function (result) {
          console.log(JSON.stringify(result))
        },
        fail: function (result) {
          console.log(JSON.stringify(result))
        }
      })
    }
  }
}
export default MainAppApi

// 分享微信
export const MainAppApiShareWx = function (options, successcb, errorcb) {
  window.AHAPP.invokeNative('h5share', {
    platform: 'weixin&ignore', //分享平台,all 为所有支持的平台    
    url: options.webpageURL, //分享内容打开地址    
    title: options.title, //标题    
    content: options.description, //描述信息   
    imgurl: options.iconURL, //分享信息的封面
    options: {
      wx_mini_program: {
        userName: 'gh_bfcd071dba17', // 小程序原始ID，当前值是 微信-汽车之家 小程序
        path: `/view/wxpay/h5/index?auto_open_from=autohome_carmal&sendfrom=wechatl&returnUrl=${encodeURIComponent(options.webpageURL)}`, // 小程序路径+参数
        type: 0 // 不传=线上、0=线上、1=开发版、2=体验版
      }
    },
    success: function (result) {
      console.log("success" + JSON.stringify(result)); // 打印客户端返回的参数内容  
    },
    fail: function (result) {
      console.log("fail" + JSON.stringify(result)
      );
    }
  })
}

// 
export const MainAppApiSharePYQ = function (options, successcb, errorcb) {
  console.log('---->', options)
  window.AHAPP.invokeNative('h5share', {
    url: '', //必须有值,但是不会使用.传个空字符串就可以
    platform: 'weixincircle', //分享平台,all 为所有支持的平台
    imgurl: options.imgurl, //分享图片地址
    binaryimage: options.binaryimage, //图片二进制串
    success: function (result) {
      log("success" + JSON.stringify(result)); // 打印客户端返回的参数内容
    },
    fail: function (result) {
      log("fail" + JSON.stringify(result));
    }
  });
}

/**
 * 跳转主软 WebView
 * https://zhishi.autohome.com.cn/home/teamplace/file?targetId=wiki_208035756
 * 20180408 新协议(wk)很早就有, 可以理解为几乎全量覆盖了
 * @param {string} url 完整的 https?/scheme 地址
 * @param {boolean} isnotwk 是否不用(wk)
 * @param params 参数合集 auto 是否去除协议头 clearLoad 去掉页面小恐龙和加载条
 * @注意 ios系统，车商城暂时不能用(wk),因为支付页面掉不起支付功能
 */
export const insidebrowser = (url, params = {}) => {
  // isOffline 离线包; transparentBg 透明背景色; navigationbarstyle 是否全屏; animationtype 页面进入方式; webviewBgcolor 鸿蒙系统下设置透明背景需要设置00000000 前两位是透明度
  const {
    isnotwk = false,
    auto = true,
    clearLoad = true,
    transparentBg = false,
    navigationbarstyle = '',
    animationtype = '',
    fullScreen = false,
    customshowanimationtype = '',
    disableBack = '',
    loadtype = 0,
    titlecolor = '',
    title = '',
    webviewBgcolor = ''
  } = params
  // 是否开启沉浸模式，安卓使用isSchemeCanAlpha:1，ios使用navalpha: 0，开启沉浸模式ios会底部会加载不到最底部，因此需要增加paddingBottom
  let hasImmersive = ''
  if (params.immersive) {
    // ios主软版本是否大于11.79.5
    hasImmersive = isGreaterThan11795() ? '&isSchemeCanAlpha=1&navalpha=0' : '&isSchemeCanAlpha=1'
  }
  let hasTitleImage = ''
  // 设置导航栏标题图片URL
  if (params.titleimageurl) {
    hasTitleImage = isNavigator() === 'iOS' ? `&titleimageurl=${params.titleimageurl}&titleImageNewStyle=1` : `&titleimageurl=${params.titleimageurl}`
  }
  // 是否设置顶部背景色
  const hasBgColor = params.bgcolor ? `&bgcolor=${params.bgcolor}` : ''
  if (!url) {
    return ''
  }
  if (window.location.search.includes('autoxcx=1') && !url.includes('autoxcx=')) {
    // 原始 URL
    const urlObj = new URL(url)
    // 添加参数
    urlObj.searchParams.append('autoxcx', '1')
    url = urlObj.toString()
  }
  // App 协议不支持 url 中带有空格
  const newUrl = url.replace(/\s/g, '')

  // url是rn地址
  if (newUrl.indexOf('rninsidebrowser') !== -1) {
    return newUrl
  }

  const type = isnotwk ? '' : 'wk',
    enUrl = encodeURIComponent(url)
  // loadtype=1  打开新的webview 有小恐龙加载（默认onload事件后消失） progressTimeout=1 1s后关闭小恐龙
  // return `autohome://insidebrowser${type}?loadtype=1&progressTimeout=1&url=${enUrl}`;
  if (clearLoad) {
    return `autohome://insidebrowser${type}?progresstimeout=0&loadtype=1${hasBgColor}&title=${title}&titlecolor=${titlecolor}&webview_bgcolor=${webviewBgcolor}&transparentBg=${transparentBg}&transparentbgv2=${transparentBg}&navigationbarstyle=${navigationbarstyle}&animationtype=${animationtype}&fullScreen=${fullScreen}&customshowanimationtype=${customshowanimationtype}&disable_back=${disableBack}&url=${enUrl}`
  } else {
    return `autohome://insidebrowser${type}?&loadtype=${loadtype}${hasBgColor}&title=${title}&titlecolor=${titlecolor}&webview_bgcolor=${webviewBgcolor}&transparentBg=${transparentBg}&transparentbgv2=${transparentBg}&navigationbarstyle=${navigationbarstyle}&animationtype=${animationtype}&fullScreen=${fullScreen}&customshowanimationtype=${customshowanimationtype}&disable_back=${disableBack}&url=${enUrl}`
  }
}


// WEBPACK FOOTER //
// ./src/environment/mainapp_api.js